import { render, staticRenderFns } from "./BadgesFilterMain.vue?vue&type=template&id=5035f820"
import script from "./BadgesFilterMain.vue?vue&type=script&lang=js"
export * from "./BadgesFilterMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports